module.exports = __webpack_public_path__ + "static/dog-2d0f93acb80ef4f4dab47a286ab36987.jpg";